import { render, staticRenderFns } from "./label-add.vue?vue&type=template&id=4118236c&scoped=true&"
import script from "./label-add.vue?vue&type=script&lang=js&"
export * from "./label-add.vue?vue&type=script&lang=js&"
import style0 from "./label-add.vue?vue&type=style&index=0&id=4118236c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4118236c",
  null
  
)

export default component.exports